import classNames from 'classnames';
import React__default from 'react';
import Styles from './LorryNumber.module.scss.js';

const LorryNumber = ({ lorryNumber, className }) => {
    return (React__default.createElement("span", { className: classNames(Styles.main, className) }, lorryNumber === null || lorryNumber === void 0 ? void 0 :
        lorryNumber.slice(0, -4),
        " ",
        React__default.createElement("span", { className: Styles.masked }, "****")));
};

export { LorryNumber as default };
//# sourceMappingURL=LorryNumber.js.map
